module.exports = "import React from 'react';\nimport LinearProgress from 'material-ui/LinearProgress';\n\nconst LinearProgressExampleSimple = () => (\n  <LinearProgress mode=\"indeterminate\" />\n);\n\nexport default LinearProgressExampleSimple;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/LinearProgress/ExampleSimple.js
 ** module id = 1006
 ** module chunks = 0
 **/